export function notifyShowingBooked(_args: {
  showingId: string;
  leadEmail: string;
  leadName: string;
  scheduledDate: string;
  scheduledTime: string;
  unitId: string;
  propertyId: string;
}): Promise<void> {
  return Promise.resolve();
}

export function notifyShowingStatusUpdated(_args: {
  showingId: string;
  leadEmail: string;
  newStatus: string;
  scheduledAt: string | null;
  unitId: string | null;
}): Promise<void> {
  return Promise.resolve();
}
